import GlobalForm from './GlobalForm';


export default function SubscribeForm() {
    const formDetails = [
        {
            entry: 'name',
            rows: 1
        },
        {
            entry: 'email',
            rows: 1
        },
    ]

  return (
    <div className="flex flex-col justify-between items-center px-4 text-white
     border-black border-dashed border-2 rounded-md bg-blue-700"
    >
        <h2 className="text-3xl black-ops-font">Join My Newsletter!</h2>
        <GlobalForm 
            formEntries={formDetails} endpoint='/add-sub/' row={true} 
            sendButton='Join Newsletter'
        />
    </div>
  )
}
